export class ImportanceCategories {
  static readonly high = 'Haute';
  static readonly average = 'Moyenne';
  static readonly low = 'Faible';
  static readonly unknown = 'Indéterminée';
}
